module.exports = __webpack_public_path__ + "fecdeb059c674551c27e8b2c957ef224.png";